export const AlertUnitEnum = {
  MINUTE: 'MINUTE',
  HOUR: 'HOUR',
  DAY: 'DAY',
  WEEK: 'WEEK',
  MONTH: 'MONTH',
};

export const AlertUnitList = [
  { label: 'Perc', value: AlertUnitEnum.MINUTE },
  { label: 'Óra', value: AlertUnitEnum.HOUR },
  { label: 'Nap', value: AlertUnitEnum.DAY },
  { label: 'Hét', value: AlertUnitEnum.WEEK },
  { label: 'Hónap', value: AlertUnitEnum.MONTH },
];

export const WeekDaysList = [
  { label: 'Hétfő', value: 1 },
  { label: 'Kedd', value: 2 },
  { label: 'Szerda', value: 3 },
  { label: 'Csütörtök', value: 4 },
  { label: 'Péntek', value: 5 },
  { label: 'Szombat', value: 6 },
  { label: 'Vasárnap', value: 7 },
];

export const MonthDaysList = Array.from({ length: 31 }, (_v, k) => ({ label: `${k + 1}.`, value: k + 1 }));
